import styled from 'styled-components'

export const DetailView = styled.div`
  .detail-item-container {
    margin-bottom: 5px;
  }

  .link-to-editor {
    display: inline-flex;
    margin-bottom: 15px;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      margin-bottom: 30px;
    }
  }

  .detail-link-container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 20px;

    @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
      flex-wrap: nowrap;
      margin-top: 30px;
    }

    a {
      color: ${ (props) => props.theme.colors['aok-gruen'] };
    }
  }
`
